import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrieveTeam, useUpdateIntraSquadMatch, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadMatchForm } from "./IntraSquadMatchForm";
export const UpdateIntraSquadMatch = () => {
    const { id } = useNumericParams();
    const { data: userIntraSquadMatchPermissions, isLoading: userIntraSquadMatchPermissionsIsLoading, error: userIntraSquadMatchPermissionsError, } = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id });
    const { canModify = false } = userIntraSquadMatchPermissions || {};
    const { isLoading: useRetrieveIntraSquadMatchIsLoading, error: useRetrieveIntraSquadMatchError, data: intraSquadMatch, } = useRetrieveIntraSquadMatch({ id, enabled: canModify });
    const { data: team, error: teamError, isLoading: teamIsLoading, } = useRetrieveTeam({ id: intraSquadMatch?.team });
    const navigate = useNavigate();
    const mutation = useUpdateIntraSquadMatch({
        id,
        team,
        onMutate: () => { },
        onSuccess: () => {
            return navigate(`/teams/${intraSquadMatch?.team}/intra-squad-matches/${id}/`);
        },
        onError: () => { },
    });
    const onSubmit = (intraSquadMatch) => {
        mutation.mutate(intraSquadMatch);
    };
    if (useRetrieveIntraSquadMatchIsLoading || teamIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (!canModify) {
        return _jsx(NotFound, {});
    }
    if (useRetrieveIntraSquadMatchError ||
        !intraSquadMatch?.team ||
        !team ||
        teamError) {
        return _jsx(ErrorView, { error: useRetrieveIntraSquadMatchError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to update Intra-Squad Match. Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update Intra-Squad Match for ", team.name] }) }), _jsx(IntraSquadMatchForm, { intraSquadMatch: intraSquadMatch, team: team, onSubmit: onSubmit })] }));
};
